<template>
  <v-container fluid>
    <v-layout column align-center justify-center>
      <v-flex class="ma-2 mb-4 text-xs-center">
        <div class="">
          {{ time | moment('dddd, MMMM D') }}
        </div>
        <div class="display-1">
          {{ time | moment('h:mm:ss a') }}
        </div>
      </v-flex>

      <v-flex xs12 class="grey lighten-3 py-3">
        <h1 class="text-xs-center">Welcome, {{ user.display_name }}!</h1>

        <v-layout v-if="currentUserClockableShift" row wrap justify-space-between class="mt-5">
          <v-flex class="pa-4">
            <h2
              class="subtle font-weight-bold"
            >
              Please confirm your shift:
            </h2>
          </v-flex>

          <v-flex class="px-4">
            <v-layout column>
              <v-flex grow>
                <ShiftItem
                  :itemData="currentUserClockableShift"
                />

                <v-btn
                  color="success"
                  class="mt-5"
                  :to="{ name: 'timeclockPunch' }"
                >
                  <v-icon left>
                    forward
                  </v-icon>
                  Confirm
                </v-btn>

              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout v-else>
          <v-flex row wrap justify-space-between class="mt-2 pa-2">
            <h2
              class="subtle font-weight-bold pa-4"
            >
            No eligible shifts to clock in for at the moment.
            </h2>
          </v-flex>
        </v-layout>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ShiftItem from '@/components/shifts/timeclockShift.vue'

export default {
  components: {
    ShiftItem
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    ...mapGetters('shifts', [
      'currentUserClockableShift',
    ]),
    ...mapState('shifts', [
      'currentUserCurrentShift',
      'currentUserNextShift'
    ]),
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  data: function () {
    return {
      time: Date.now(),
      showingNext: false,
    }
  },
  created () {
    this.tickTime()
    this.fetchData()
  },
  methods: {
    updateTime () {
      this.time = Date.now()
    },
    tickTime() {
      var timerId = setInterval(this.updateTime, 1000)
      this.updateTime()
    },
    fetchData () {
      const userId = this.user.id
      this.$store.dispatch('shifts/getCurrentUserUpcoming', userId)
    },
    toggleNextShift() {
      this.showingNext = !this.showingNext
    },
    goToClockin () {
      this.$router.push({ name: 'timeclockPunch' })
    },
  },
}
</script>

<style scoped>
#dashboard-container {
}
</style>
